import * as React from "react";
function SvgArrowsShrinking(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <g
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
      >
        <path d="M17 4v11h11M15 28V17H4M18 14L30 2M2 30l12-12" />
      </g>
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgArrowsShrinking);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
